import VisitSummaryPrintModal from '../../../../../components/common/VisitSummaryDocument/VisitSummaryPrintModal'
import { usePortalVisitSummary } from '../../../../../hooks/usePatientSummary'
import { clinicBrandingFromEnv } from '../../../../../utils/clinicBranding'
import { isInpatientFacts } from '../../../../../utils/visitSummaryVariant'

type Props = {
  id?: string
  onClose: () => void
}

/**
 * Patient portal — the read-only visit summary for one completed encounter, opened from the
 * Encounters tab's "Visit summary" action. Big, plain-language, easy to print or save as a PDF —
 * patients are not expected to be tech-savvy. The letterhead has the clinic's name, logo and phone
 * (a patient login has no staff facility to take an address from).
 */
export default function VisitSummaryModal({ id, onClose }: Props) {
  const { isError, isLoading, snapshot } = usePortalVisitSummary(id)
  // An admitted patient's summary is their discharge instructions (known once the snapshot has loaded).
  const inpatient = isInpatientFacts(snapshot?.facts)

  return (
    <VisitSummaryPrintModal
      branding={clinicBrandingFromEnv()}
      data={
        snapshot && {
          doctorNote: snapshot.doctor_note,
          facts: snapshot.facts,
          instructionsHtml: snapshot.instructions_html,
          language: snapshot.language,
          translationHtml: snapshot.translation_html
        }
      }
      errorText="We could not load this visit summary. Please try again."
      isError={isError}
      isLoading={isLoading}
      loadingText="Loading your visit summary…"
      onClose={onClose}
      title={inpatient ? 'Your discharge instructions' : 'Your visit summary'}
    />
  )
}
